import React from 'react';
import PropTypes from 'prop-types';
import { Cookies } from 'react-cookie';
import { Dialog, IconButton, Paper, Subheader } from 'material-ui';
import { ActionVisibility, ActionVisibilityOff } from 'material-ui/svg-icons';
import { white } from 'material-ui/styles/colors';
import ActionFavorite from 'material-ui/svg-icons/action/favorite';
import styles from './TrailInfo.css';
import Info from '../../common/Info/Info';
import QRCodeIcon from '../../icon/QRCodeIcon';
import style from '../../../styles/styles';
import withTranslation from '../../../hoc/withTranslation';
import APIService from '../../../services/api';
import ModuleService from '../../../services/module';
import { RICHTEXT } from '../../../constants/customfiled';

const cookies = new Cookies();
const Timestamp = require('react-timestamp');

class TrailInfo extends React.Component {
    static propTypes = {
        trail: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        customFields: PropTypes.arrayOf(PropTypes.object),
        lang: PropTypes.string,
    };

    state = {
        img: null
    };

    static defaultProps = {
        customFields: [],
        lang: 'fr'
    };

    onClose = () => {
        this.setState({ img: null });
    }

    getQrCode = async() => {
        const img = await APIService.getDynamicLinkQrCode(this.props.app.id, 'trails', this.props.trail.id, 'png', cookies.get('token'), this.props.lang);
        this.setState({ img: window.webkitURL.createObjectURL(img) });
    }

    render() {
        const trail = this.props.trail;

        return (
            <Paper>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('generic.information')}
                    {ModuleService.hasModule(this.props.app, ModuleService.DYNAMIC_LINK)
                    && <IconButton
                        style={styles.qrCodeIcon}
                        tooltipPosition='bottom-left'
                        onClick={this.getQrCode}
                    >
                        <QRCodeIcon color={white} />
                    </IconButton>
                    }
                    {trail.is_favorite &&
                    <IconButton
                        style={styles.rightIcon}
                        tooltip={this.props.t('module.open_explore.favorite_trail')}
                        tooltipPosition="bottom-left"
                        disableTouchRipple={true}
                    >
                        <ActionFavorite color={white} />
                    </IconButton>
                    }
                    <IconButton
                        style={styles.rightVisibleIcon}
                        tooltip={this.props.t(trail.visible
                            ? 'module.open_explore.visible_trail'
                            : 'module.open_explore.not_visible_trail')}
                        tooltipPosition="bottom-left"
                        disableTouchRipple={true}
                    >
                        {trail.visible
                            ? <ActionVisibility color={white} />
                            : <ActionVisibilityOff color={white} />
                        }
                    </IconButton>
                </Subheader>
                <div style={style.paper}>
                    <Info
                        title={this.props.t('generic.identifier')}
                        content={trail.id}
                    />
                    {trail.gpx &&
                    <Info
                        title={this.props.t('module.open_explore.gpx_file')}
                        content={<a href={trail.gpx}>{trail.gpx}</a>}
                    />
                    }
                    {trail.kml &&
                    <Info
                        title={this.props.t('module.open_explore.kml_file')}
                        content={<a href={trail.kml}>{trail.kml}</a>}
                    />
                    }
                    {trail.geojson &&
                    <Info
                        title={this.props.t('module.open_explore.geojson_file')}
                        content={<a href={trail.geojson}>{trail.geojson}</a>}
                    />
                    }
                    <Info
                        title={this.props.t('generic.name')}
                        content={this.props.trail.name}
                    />
                    <Info
                        title={this.props.t('generic.description')}
                        content={this.props.trail.description}
                        html={true}
                    />
                    {trail.tag &&
                    <Info
                        title={this.props.t('generic.tag')}
                        content={trail.tag}
                    />
                    }
                    {this.props.trail.custom_fields &&
                    this.props.trail.custom_fields.filter(cf => cf.value != null).map((cf) => {
                        let customField = this.props.customFields.find(item => item.id === cf.id);
                        let name = cf.id;

                        if (customField) {
                            name = customField.name;
                        }

                        if (cf.tag && cf.tag.length > 0) {
                            name += ' (' + cf.tag + ')';
                        }
                        return (
                            <Info
                                key={cf.id}
                                title={name}
                                content={cf.value}
                                html={customField.type === RICHTEXT}
                            />
                        );
                    })}
                    <Info
                        title={this.props.t('generic.created_at')}
                        content={<Timestamp time={this.props.trail.created_at} format="full"
                                            twentyFourHour />}
                    />
                    <Info
                        title={this.props.t('generic.updated_at')}
                        content={(
                            this.props.trail.updated_at &&
                            <Timestamp time={this.props.trail.updated_at} format="full"
                                       twentyFourHour />
                        ) || this.props.t('generic.updated_never')}
                        divider={false}
                    />
                </div>
                <Dialog
                    open={this.state.img !== null}
                    onRequestClose={this.onClose}
                    modal={false}
                    contentStyle={styles.modal}
                    autoDetectWindowHeight={true}
                >
                    <img src={this.state.img} alt={"Erreur lors de la génération de l'image"}/>
                </Dialog>
            </Paper>
        );
    }
}

export default withTranslation(TrailInfo);



// WEBPACK FOOTER //
// src/components/openexplore/TrailInfo/TrailInfo.js